import React, { Component } from 'react';
import './App.css';
import './Style.css';
import './Modal.css';
import SearchBar from './Components/Searchbar'


class App extends Component {
  render() {
    return (
     <SearchBar />
    );
  }
}

export default App;
